import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { ToastrService } from 'ngx-toastr'

@Component({
  selector: 'app-variable-pay-email-content',
  templateUrl: './variable-pay-email-content.component.html',
  styleUrls: ['./variable-pay-email-content.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VariablePayEmailContentComponent implements OnInit {

  buttonColorName:any;
  EmailContent:any
  isEditEmail = false
  emailContentSubject:any;
  isInvalidIncrementEmailSubject:any = false;
  emailContentBody:any;
  isInvalidsetIncrementEmailContent:any = false;
  loggedInUserCompanyID:any;
  fromYear:any;
  toYear:any;
  editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: '400px',
      minHeight: '0',
      maxHeight: 'auto',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter Email here...',
      defaultParagraphSeparator: '',
  }
  vppolicySubjectCharValidation = false;


  constructor(public dialog: MatDialog, public router: Router,  private httpService: HttpService,
    private config: Config, private encryptionService: EncryptionService,private toastr:ToastrService) { }

  ngOnInit() {
    // this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.getVPPolicyFile();
  }

  onClickEdit() {
    this.isEditEmail = true;
  }

  isDiscardChanges(){
    this.isEditEmail = false;
    this.emailContentSubject = "";
    this.emailContentBody = "";
    this.getVPPolicyFile()
  }

  onClickGoToVariablePay(operation: any) {
    this.router.navigate(['/home/hrportal/variablepay', { operation: operation }]);
  }

  onClickSaveBtn(){
    if (!this.emailContentSubject && this.emailContentBody) {
     window.alert("Enter Email Subject")
    }
    
    if (!this.emailContentBody && this.emailContentSubject) {
      window.alert("Enter Email")
    }

    if (!this.emailContentSubject && !this.emailContentBody) {
      window.alert("Enter Email and Email Subject")
    }

    if (this.emailContentSubject && this.emailContentBody) {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '30%',
        width: '30%',
        data: {
          msg: 'Email Template Updated Successfully',
          btn2: 'Done',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        },
      });
  
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          this.isEditEmail = false;
          this.emailContentSubject = '';
          this.emailContentBody = '';
          const request = {
            "companyId": this.loggedInUserCompanyID,
            "emailContentBody": this.emailContentBody,
            "emailContentSubject": this.emailContentSubject,
            "fromYear": 0,
            "variablePayPolicyFileName": null,
            "variablePayPolicyUrl": null,
            "toYear": 0
          };
          this.httpService.callPostService(this.config.variablePayPolicyUpload, request).subscribe((result) => { 
            // this.getIncrementSetup();
            console.log(result)
          });
        }
      });
    }
  }
  vpletterContent:any=`Dear <b>#EMPLOYEE_NAME#</b>, 
      <br /> <br />
      We are happy to announce that you are eligible for Variable Pay (VP) for [Period/Year] as a recognition of your contributions and dedication.
      <br /><br />
      To view your VP letter, please follow these simple steps:
      <br />
      <ol>
        <li style="margin-left:15px;">Click on the PHI HRIS login link: [Login Link]</li>
        <li style="margin-left:15px;">Enter your credentials to access system.</li>
        <li style="margin-left:15px;">Navigate to the VP Module from your Landing page</li>
        <li style="margin-left:15px;">Your VP letter is available there for your reference.</li>
      </ol>
      <br />
      We truly appreciate your hard work and commitment to [Company Name], and we look forward to achieving more success together!
      <br /><br />
      For any queries, feel free to reach out to [HR Contact Details].
      <br />
      Congratulations once again!
      <br/><br/>
      Best regards, 
      <br />[HR Name],
      <br />[HR Position],
      <br />[Company Name],
      <br />[HR Contact Details]`;
  vpPolicyUrlSubject:any=`Congratulations! You Are Eligible for Variable Pay – [Period/Year]`;

  saveVPPolicyFile() {
    if(this.vpletterContent == ''){
      this.toastr.error('Please fill email body.', '', {
        timeOut: 3000,
    });
    return;
    }
    if(this.vpPolicyUrlSubject == ''){
      this.toastr.error('Please fill email subject.', '', {
        timeOut: 3000,
    });
    return;
    }
    if(this.vpPolicyUrlSubject.length >= 255){
      this.vppolicySubjectCharValidation = true;
    }else{
      this.vppolicySubjectCharValidation = false;
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "frequencyCycle": null,
        "fromYear": null,
        "isDeleted": false,
        "relatedToName": "Email Content",
        "toYear": null,
        "vpPolicyFileNameBody": this.vpletterContent,
        "vpPolicyUrlSubject": this.vpPolicyUrlSubject
      };
      this.httpService.callPostService(this.config.saveVPPolicyFile, request).subscribe((result: any) => {
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: result?.message,
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false,
          },
        });
        successdialogRef.afterClosed().subscribe(result => {
          this.getVPPolicyFile();
          this.isEditEmail = false;
        });
      });
    }
  }
  getVPPolicyFile() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": null,
      "fromYear": null,
      "relatedToName": "Email Content",
      "toYear": null,
      "isShowLetterLink": false
    };
    this.httpService.callPostService(this.config.getVPPolicyFile, request).subscribe((result: any) => {
      if(result?.data!=null){
        this.vpPolicyUrlSubject = result.data?.vpPolicyUrlSubject;
        this.vpletterContent = result.data?.vpPolicyFileNameBody
      }else{
        this.vpletterContent=`Dear <b>#EMPLOYEE_NAME#</b>, 
        <br /> <br />
        We are happy to announce that you are eligible for Variable Pay (VP) for [Period/Year] as a recognition of your contributions and dedication.
        <br /><br />
        To view your VP letter, please follow these simple steps:
        <br />
        <ol>
          <li style="margin-left:15px;">Click on the PHI HRIS login link: [Login Link]</li>
          <li style="margin-left:15px;">Enter your credentials to access system.</li>
          <li style="margin-left:15px;">Navigate to the VP Module from your Landing page</li>
          <li style="margin-left:15px;">Your VP letter is available there for your reference.</li>
        </ol>
        <br />
        We truly appreciate your hard work and commitment to [Company Name], and we look forward to achieving more success together!
        <br /><br />
        For any queries, feel free to reach out to [HR Contact Details].
        <br />
        Congratulations once again!
        <br/><br/>
        Best regards, 
        <br />[HR Name],
        <br />[HR Position],
        <br />[Company Name],
        <br />[HR Contact Details]`;
    this.vpPolicyUrlSubject=`Congratulations! You Are Eligible for Variable Pay – [Period/Year]`;
      }
    });
  }

}
